export default __webpack_public_path__ + "static/media/call-outgoing.4cc64758.svg";